import { useQuery } from '@tanstack/react-query';
import { useBoundStore } from '@Store/index.ts';
import { HttpService } from '@Services/api/httpService.ts';
import type { PlanPickerResponse } from '@Pages/happyFlowPages/planSelection/types.ts';

export const getPlans = async () => {
  const { customerId, availablePromoCodes } = useBoundStore.getState().customer;
  let promoCodes = availablePromoCodes;
  if (!customerId) return;
  const isEmbedded = useBoundStore.getState().onboardingSlice.getIsEmbedded();
  const url = isEmbedded
    ? `v4/secureonboarding/partner/user/${customerId}/account/plans`
    : `v4/secureonboarding/user/${customerId}/account/plans`;

  const { discountPartnerId } = useBoundStore.getState().onboardingSlice;

  if (discountPartnerId) {
    promoCodes = {
      PREMIUM: discountPartnerId,
      PRO_V2: discountPartnerId,
      SMART: discountPartnerId,
    };
  }

  try {
    const { data } = await HttpService.post(url, promoCodes);
    return data as PlanPickerResponse;
  } catch (error) {
    throw error;
  }
};

export const getPlansQueryOptions = {
  queryKey: ['getPlans'] as const,
  queryFn: getPlans,
};

export const useGetPlans = () => useQuery(getPlansQueryOptions);
